const $inject = ['moment', '$q', '$http', 'APP_CONFIG'];

const seatMapService = function (moment, $q, $http, APP_CONFIG) {

  let service = {
    init,
    get,
    putSeat,
    formatDates,
    setActiveSeatMap,
    deactivateSeat,
    findIdentifierIn,
    setActive,
    buildDeck,
    resetSeatMap,
    cleanActiveSeats,
    findSeat,
    showLegs,
    lookUpSeatNumber,
    findReplaceFlight,
    paxArray: [],
    activePax: undefined,
    activeFlight: undefined,
    activeTransport: undefined,
    activeSeatMap: undefined,
    activeDeck: undefined,
    activeSeat: undefined,
    showModal: false,
    showKey: false,
    showPaymentOptions: false,
    showSeatSelector: false,
    savingSeatSelection: false,
    error: false
  };

  function init(passengers, paxId) {
    service.paxArray = [];
    service.activePax = undefined;
    service.activeFlight = undefined;
    service.activeSeatMap = undefined;
    service.activeDeck = undefined;
    service.activeSeat = undefined;
    service.showKey = false;
    service.showPaymentOptions = false;
    service.savingSeatSelection = false;
    service.error = false;

    passengers.forEach(pax => {
      if (pax.Flights.length > 0) {
        pax.Flights = service.formatDates(pax.Flights);
        if (pax.Identifier === paxId) {
          service.paxArray.unshift(pax);
        } else {
          service.paxArray.push(pax);
        }
      }
    });
  }

  function get(itineraryId, passengerId, sectorId) {
    let deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', { itineraryId, passengerId, sectorId }, 'seatmap');

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then(function (res) {
        let data = res.data;
        if (data) {
          deferred.resolve(data);
        } else {
          deferred.reject();
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function putSeat(seat, flight, transport, payment) {
    let deferred = $q.defer();

    const seatObj = {
      PaymentMethod: null,
      Seats: {
        SeatNumber: seat.Id,
        Carrier: transport.Operator,
        FlightNumber: transport.Id,
        OriginLocationCode: transport.Origin,
        LocationCode: transport.Destination
      }
    };

    if (payment && seat.Price) {
      let thisSeat = seatObj.Seats;

      thisSeat.SeatAmount = seat.Price.Amount;
      thisSeat.TaxAmount = seat.Price.SeatTaxAmount;
      thisSeat.SeatCurrencyCode = seat.Price.CurrencyCode;
      thisSeat.BaseCurrency = {
        Code: seat.Price.CurrencyCode,
        TaxAmount: seat.Price.SeatTaxAmount,
        FeeAmount: 0,
        Amount: seat.Price.Amount,
        TotalAmount: seat.Price.Amount
      };

      seatObj.PaymentMethod = {
        SectorGroupIdentifier: flight.GroupIdentifier,
        SectorIdentifier: flight.Identifier,
        Type: "Seat"
      };

      if (payment.PaymentType === 'Card') {
        seatObj.PaymentMethod.Card = payment;
      }

      if (payment.PaymentType === 'Invoice') {
        seatObj.PaymentMethod.Invoice = {
          Reference: 'Invoice'
        }
      }
    }

    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', {
      itineraryId: flight.ItineraryIdentifier,
      passengerId: flight.PassengerIdentifier,
      sectorId: flight.Identifier
    }, 'seat');

    $http.put(apiConfig.url, seatObj, {apiVersion: apiConfig.version})
      .then(res => {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function formatDates(flights) {
    return flights.map(flight => {
      flight.dateFormatted = moment(flight.Departure.Date, 'YYYY-MM-DD').format('ddd, MMM M');
      return flight;
    });
  }

  function setActiveSeatMap(seatMap) {
    service.deactivateSeat();
    service.activeSeatMap = seatMap;
  }

  function deactivateSeat() {
    if (service.activeSeat) {
      service.activeSeat.active = false;
    }

    service.activeSeat = undefined;
  }

  function findIdentifierIn(id, obj, prop) {
    let result = undefined;

    obj[prop].every(x => {
      if (x.Identifier === id) {
        result = x;
        return false;
      }

      return true;
    });

    return result;
  }

  function setActive(data, target) {
    if (service[target]) {
      service[target].active = false;
    }

    data.active = true;
    service[target] = data;

    return data;
  }

  function buildDeck(deck) {
    const formatted = [];

    deck.Cabins.forEach((cabin) => {
      cabin.formattedRows = buildRows(cabin.Rows);
      cabin.maxRowItems = maxRowItems(cabin.formattedRows);
      formatted.push(cabin);
    });

    return formatted;
  }

  function buildRows(rows) {
    return _.flowRight(functionalRowFormat, purgeEmptyRows, combiningFunctionTypes, addAisles)(rows);
  }

  function addAisles(rows) {
    const results = [];

    rows.forEach((row, rowIndex) => {
      const insertAt = [];

      results.push({Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: angular.copy(row.Items)});

      row.Items.forEach((item, itemIndex) => {
        if (item.RowLocation === 'WindowAisle' || item.RowLocation === 'Aisle') {
          insertAt.push({itemIndex: itemIndex + 1})
        }
      });

      if (insertAt.length > 0) {
        results[rowIndex].Items.splice(insertAt[0].itemIndex, 0, {FunctionType: 'Aisle'});
      }

      if (insertAt.length > 1 && (insertAt[insertAt.length - 1].itemIndex - insertAt[0].itemIndex > 1)) {
        results[rowIndex].Items.splice(insertAt[insertAt.length - 1].itemIndex, 0, {FunctionType: 'Aisle'});
      }
    });

    return results;
  }


  function combiningFunctionTypes(rows) {
    let results = [];
    let rowIndex = 0;

    rows.forEach(row => {
      results.push({Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: []});
      let functionalItemBlock = undefined;
      let prevItem = undefined;

      row.Items.forEach(item => {
        results[rowIndex].Items.push(item);

        let isFunctionalItem = isFunctionalItemFn(item);

        if (isFunctionalItem && prevItem && prevItem.FunctionType === item.FunctionType && prevItem.Location === item.Location) {
          item.hide = true;
          if (functionalItemBlock) {
            functionalItemBlock.expandRight += 1;
          } else {
            functionalItemBlock = prevItem;
            functionalItemBlock.expandRight = 2;
          }
          functionalItemBlock.RowLocation = item.RowLocation;
        } else {
          prevItem = undefined;
          functionalItemBlock = undefined;
        }

        if (isFunctionalItem) {
          prevItem = item;
        }
      });

      rowIndex = rowIndex + 1;
    });

    return results;
  }

  function expandRowVertical(rows) {
    let prevRow = undefined;

    rows.forEach(row => {
      row.Items.forEach((item, itemIndex) => {
        let isFunctionalItem = isFunctionalItemFn(item);

        if (prevRow) {
          let prevRowItem = prevRow.Items[itemIndex];
          if (prevRowItem && isFunctionalItem && item.FunctionType === prevRowItem.FunctionType && item.expandRight === prevRowItem.expandRight) {
            prevRowItem.expandDown = 2; // Limit to 2 as any more looks stupid when rendered.
            item.hide = true;
          }
        }
      });

      prevRow = row;
    });

    return rows;
  }

  function purgeEmptyRows(rows) {

    rows.forEach(row => {
      let hide = true;
      let noSeats = true;

      row.Items.forEach(item => {

        if (!item.hide) {
          hide = false;
        }

        if (item.hasOwnProperty('Available')) {
          noSeats = false;
        }
      });

      row.noSeats = noSeats;
      row.hide = hide;
    });

    return rows;
  }

  function functionalRowFormat(rows) {

    rows.forEach(row => {
      if (row.noSeats && !row.hide) {

        const centreItem = {
          FunctionType: 'Combined',
          Location: 'Centre',
          types: []
        };

        const indexes = [];

        row.Items.forEach((item, index) => {
          if (item.Location === 'Centre' && item.FunctionType != 'Storage') {
            centreItem.types.push(item.FunctionType);
            indexes.push(index);
          }
        });

        _.pullAt(row.Items, indexes);
        centreItem.types = _.uniq(centreItem.types);

        if (centreItem.types.length > 0) {
          row.Items.push(centreItem);
        }
      }
    });

    return rows;
  }

  function maxRowItems(rows) {
    let max = 0;

    rows.forEach(row => {
      if (row.Items.length > max) {
        max = row.Items.length
      }
    });

    return max;
  }

  function isFunctionalItemFn(item) {
    return item.hasOwnProperty('FunctionType') && item.FunctionType !== 'Aisle' && item.FunctionType !== 'NoSeat';
  }

  function resetSeatMap() {
    service.activeSeatMap = undefined;

    if(service.activeDeck) {
      service.activeDeck.active = false;
      service.activeDeck = undefined;
    }
  }

  function cleanActiveSeats(seats) {
    seats.Decks.forEach(deck => {
      deck.Cabins.forEach(cabin => {
        if (cabin.formattedRows) {
          cabin.formattedRows.forEach(row => {
            row.Items.map(seat => {
              seat.active = false;
              return seat;
            })
          })
        }
      })
    });
  }

  function findSeat(deck, seatNumber) {
    deck.Cabins.forEach(cabin => {
      cabin.formattedRows.forEach(row => {
        row.Items.map(seat => {
          if (seat.Id === seatNumber) {
            seat.active = true;
          }
          return seat;
        })
      })
    });

  }

  function showLegs(flight) {
    if (!flight.showStops) {
      flight.showStops = true;

      if (flight.showStops) {
        flight.loadingSeatMaps = true;
        //const activeFlight = service.setActive(flight, 'activeFlight');

        service.get(flight.ItineraryIdentifier, flight.PassengerIdentifier, flight.Identifier).then(data => {
          flight.loadingSeatMaps = false;
          flight.seatmaps = true;
          flight.transports = data.Transport;
        });

      } else {
        flight.seatmaps = false;
      }
    }
  }

  function lookUpSeatNumber(journey, transport) {
    const origin = transport.Origin;

    if (journey.Seat.OriginLocationCode === origin) {
      return journey.Seat.SeatNumber;
    }

    let seat = undefined;

    journey.Stops.forEach(stop => {
      if (stop.DepartsCode === origin) {
        seat = stop.Seat.SeatNumber;
      }
    });

    return seat;
  }

  function findReplaceFlight(newFlight, paxArray) {
    const pax = _.find(paxArray, function (pax) {
      return pax.Identifier === newFlight.PassengerIdentifier;
    });
    const flight = _.find(pax.Flights, function (flight) {
      return flight.Identifier === newFlight.Identifier;
    });

    _.merge(flight, newFlight);
  }

  return service;
};

seatMapService.$inject = $inject;

export default seatMapService;



// WEBPACK FOOTER //
// ./src/services/seatMapService.js